/** Return a random integer from 0 to max inclusive. */
export function getRandomInt(max: number): number {
   return Math.floor(Math.random() * (max + 1));
}

/** Return a random item from the array, or null when it is empty. */
export function getRandomItem<T>(items: readonly T[]): T | null {
   if (items.length === 0) {
      return null;
   }
   return items[getRandomInt(items.length - 1)];
}

/** Return a random float from 0 up to max. */
export function getRandomFloat(max: number): number {
   return Math.random() * max;
}

/**
 * Pseudo UUID from: https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
 */
export function uuidv4(): string {
   /* eslint-disable */
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
   });
   /* eslint-enable */
}

/** Return a random alphanumeric string of the given length. */
export function randomString(length: number): string {
   let result = '';
   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   const charactersLength = characters.length;
   for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

/** Sort `values` in place and return the lowest `percentile` (0 to 1.0) fraction of them. */
export function getWithinPercentileValues(values: number[], percentile: number): number[] {
   const sortedValues = values.sort((a, b) => a - b);
   const index = Math.floor(values.length * percentile);
   return sortedValues.slice(0, index);
}

/** Sort `values` in place and return the values at or above the `percentile` (0 to 1.0) cut. */
export function getAbovePercentileValues(values: number[], percentile: number): number[] {
   const sortedValues = values.sort((a, b) => a - b);
   const index = Math.floor(values.length * percentile);
   return sortedValues.slice(index);
}

/** Sum the values; 0 for an empty array. */
export function sumArray(values: number[]): number {
   return values.reduce((acc, val) => acc + val, 0);
}
